import React from "react";
import SESTree from "../../../assets/images/SES_TreeRevised1.png";
import Layout from "../../Layout";
import HeaderWelcome from "./HeaderWelcome";

const Welcome = () => (
  <Layout>
    <HeaderWelcome />
    <main className="layout-container" aria-labelledby="welcomHeading">
      <div className="container">
        <div className="left-panel-s1">
          <h1 className="form-title g-clr" id="welcomeHeading">Welcome to Direct!</h1>
          <section className="text-size6" aria-label="About Direct email">
            <p>
              You currently do not have Direct email account to access with our
              Webmail system. Using our secure messaging system will allow you
              to receive admit and discharge notifications, submit information
              to plans to expedite payment, exchange referrals, pre-op notes,
              immunization records, patient histories, and many more.
            </p>
            <p>
              To begin using Direct, please contact your administrator to help
              get your account set up with a Direct email address.
            </p>
          </section>
        </div>
        <div className="right-panel-s1">
          <aside aria-label="Healthcare industry illustration">
            <img
              src={SESTree}
              className="w-full"
              alt="A tree illustration made up of healthcare industry icons representing various medical services"
            />
          </aside>
        </div>
      </div>
    </main>
  </Layout>
);

export default Welcome;
